<div class="container">
    <div class="primary">
        <ng-container *ngIf="!showSelect; else showForm">
            Select a point to continue.
        </ng-container>
        <ng-container *ngIf="!plansExist">
            <span *ngIf="!lat || !long">No information found.</span>
            <span *ngIf="lat && long">
                No information found near <span style="font-size: 11px;">{{ lat }}, {{ long }}</span>
            </span>
        </ng-container>
        <ng-template #showForm>
            <div class="section" *ngIf="plansExist">
                <h4>Plan Details</h4>
                <table class="table table-condensed" *ngFor="let plan of irowPlans">
                    <tr>
                        <th style="border-top: none;" width="175">State Route</th>
                        <td style="border-top: none;">{{ plan.stRtNo }}</td>
                    </tr>
                    <tr>
                        <th>LR Reference</th>
                        <td>{{ plan.lrReference }}</td>
                    </tr>
                    <tr>
                        <th>Segment Begin</th>
                        <td>{{ plan.segBgn }}</td>
                    </tr>
                    <tr>
                        <th>Offset Begin</th>
                        <td>{{ plan.offsetBgn }}</td>
                    </tr>
                    <tr>
                        <th>Station Begin</th>
                        <td>{{ plan.stationBgn }}</td>
                    </tr>
                    <tr>
                        <th>Segment End</th>
                        <td>{{ plan.segEnd }}</td>
                    </tr>
                    <tr>
                        <th>Offset End</th>
                        <td>{{ plan.offsetEnd }}</td>
                    </tr>
                    <tr>
                        <th>Station End</th>
                        <td>{{ plan.stationEnd }}</td>
                    </tr>
                    <tr>
                        <th>Year Approved</th>
                        <td>{{ plan.yearApproved | date:'MM-dd-yyyy' }}</td>
                    </tr>
                    <tr>
                        <th>Right of Way Plan</th>
                        <td>{{ plan.rightOfWayPlan }}</td>
                    </tr>
                    <tr>
                        <th>Plan Reference Number</th>
                        <td>{{ plan.planRefNo }}</td>
                    </tr>
                    <tr>
                        <th>District</th>
                        <td>{{ plan.districtNum }}</td>
                    </tr>
                    <tr>
                        <th>County</th>
                        <td>{{ plan.ctyCode }}</td>
                    </tr>
                    <tr>
                        <th>Documents</th>
                        <td>
                            <table>
                                <tr *ngFor="let planDocument of plan.planDocuments">
                                    <td>
                                        <a href="{{documentUrl}}/{{planDocument.ecsId}}?sourceName=iROWPlans" target="_blank" rel="noopener" style="text-decoration: underline;">{{ planDocument.name }}</a>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td *ngIf="!plan.planExists">Could not find document(s) for this record</td>
                    </tr>
                </table>
            </div>
        </ng-template>
    </div>
</div>
